/**
 * ==========================================
 * CONFIGURACIÓN CENTRAL DE PERFORMANCE
 * ==========================================
 * 
 * Este archivo centraliza todos los umbrales y configuraciones
 * relacionadas con la detección de performance del dispositivo.
 * 
 * Modifica estos valores para ajustar el comportamiento del sistema.
 */

export const PERFORMANCE_CONFIG = {
  VERY_LOW_RAM_GB: 2,
  MODERATE_LOW_RAM_GB: 3,
  LOW_CPU_CORES: 3,
  HIGH_MEMORY_USAGE_PERCENT: 60,
  MODERATE_MEMORY_USAGE_PERCENT: 50,
  WARNING_MEMORY_USAGE_PERCENT: 60,
  MEMORY_CHANGE_THRESHOLD: 5,
  LOW_PERFORMANCE_ROW_HEIGHT: 35,
  HIGH_PERFORMANCE_ROW_HEIGHT: 24,
  DEFAULT_DEVICE_MEMORY_GB: 4,
  DEFAULT_CPU_CORES: 2,
  ENABLE_DEBUG_LOGS: true,
  ENABLE_MEMORY_WARNINGS: true,
  ENABLE_PERFORMANCE_CHANGE_LOGS: true,
} as const


export type PerformanceConfigKey = keyof typeof PERFORMANCE_CONFIG

export const getPerformanceConfig = <T extends PerformanceConfigKey>(
  key: T
): typeof PERFORMANCE_CONFIG[T] => {
  return PERFORMANCE_CONFIG[key]
}

export const getFullPerformanceConfig = () => {
  return { ...PERFORMANCE_CONFIG }
}

export const validatePerformanceConfig = (): boolean => {
  const config = PERFORMANCE_CONFIG

  if (config.VERY_LOW_RAM_GB >= config.MODERATE_LOW_RAM_GB) {
    return false
  }

  if (config.MODERATE_MEMORY_USAGE_PERCENT >= config.HIGH_MEMORY_USAGE_PERCENT) {
    return false
  }

  if (config.LOW_PERFORMANCE_ROW_HEIGHT <= config.HIGH_PERFORMANCE_ROW_HEIGHT) {
    return false
  }

  if (config.HIGH_MEMORY_USAGE_PERCENT > 100 || config.HIGH_MEMORY_USAGE_PERCENT < 0) {
    return false
  }

  return true
}

validatePerformanceConfig()
